import { Grid } from '@material-ui/core';
import {
  Entity,
  ComponentEntity,
  RELATION_HAS_PART,
  RELATION_OWNER_OF,
  RELATION_PART_OF,
  RELATION_OWNED_BY,
} from '@backstage/catalog-model';
import { EntityTable, useEntity } from '@backstage/plugin-catalog-react';

import { TableColumn } from '@backstage/core-components';

import { useEntities, getRelatedEntities } from '../../util';

const useComponents = (): Entity[] => {
  const list = useEntities(); // API call to get all known entities
  const { entity } = useEntity(); // entity is our organization

  const domains = getRelatedEntities([entity], RELATION_OWNER_OF, list);
  const systems = getRelatedEntities(domains, RELATION_HAS_PART, list);
  const components = getRelatedEntities(systems, RELATION_HAS_PART, list);

  return components;
};

const reportColumns = (): TableColumn<ComponentEntity>[] => [
  EntityTable.columns.createEntityRefColumn({ defaultKind: 'component' }),
  EntityTable.columns.createEntityRelationColumn({
    title: 'Team',
    relation: RELATION_OWNED_BY,
    defaultKind: 'group',
  }),
  EntityTable.columns.createEntityRelationColumn({
    title: 'Product',
    relation: RELATION_PART_OF,
    defaultKind: 'system',
    filter: {
      kind: 'system',
    },
  }),
  {
    title: 'Description',
    field: 'metadata.description',
  },
];

const columns = reportColumns();

// This component will show all services owned by an organization
export const TeamServicesCard = () => {
  const components = useComponents().filter(
    c =>
      c.kind === 'Component' &&
      (c.spec?.type === 'service' || c.spec?.type === 'website'),
  );

  return (
    <Grid item>
      <EntityTable
        title="Service Ownership"
        entities={components as ComponentEntity[]}
        columns={columns}
      />
    </Grid>
  );
};

// This component will show all services owned by an organization
export const TeamLibrariesCard = () => {
  const components = useComponents().filter(
    c => c.kind === 'Component' && c.spec?.type === 'library',
  );

  return (
    <Grid item>
      <EntityTable
        title="Library Ownership"
        entities={components as ComponentEntity[]}
        columns={columns}
      />
    </Grid>
  );
};
